import { Component, OnInit, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { EnvironmentVariablesService } from '../services/environment-variables.service';
import { UserService } from '../services/user.service';
import { ContentfulService } from '../services/contentful.service';
import { GcmErrorComponent, GcmLoadingService, AccountMenuItem } from '@gcm/gcm-ui-angular';
import { PageErrorResponse } from '../models/interfaces/contentful-response.interface';

@Component({
  selector: 'app-auth-error',
  imports: [GcmErrorComponent],
  templateUrl: './auth-error.component.html',
  styleUrls: []
})

export class AuthErrorComponent implements OnInit {
  private loading = inject(GcmLoadingService);
  evService = inject(EnvironmentVariablesService);
  private userService = inject(UserService);
  private contentfulService = inject(ContentfulService);

  private readonly pageNotFound = toSignal(
    (this.contentfulService.getPageNotFound(this.evService.contentful['previewFlag'] as boolean) as unknown as import('rxjs').Observable<PageErrorResponse>).pipe(
      map((result: PageErrorResponse) => result?.data?.page404Error)
    ),
    { initialValue: null }
  );
  readonly emailAddressText = computed(() => this.pageNotFound()?.emailAddressText ?? '');
  readonly mailToEmailAddress = computed(() => this.pageNotFound()?.mailToEmailAddress ?? '');
  buttonLinks: { goToButtonText: string; goToRouterLink: string }[] = [];
  welcomeName = '';
  accountMenuItems: AccountMenuItem[] = [];

  ngOnInit(): void {
    this.checkUserDocsAccess();
    this.getProfileItems();
  }

  checkUserDocsAccess() {
    if (!this.userService.user()) return;
    if (this.userService.getApplicationAccess().indexOf('clientdocs') > -1) {
      // check if user has access to client docs, if yes then show client docs as client docs url
      this.buttonLinks.push({
        goToButtonText: 'GO TO CLIENTDOCS',
        goToRouterLink: this.evService.clientDocs
      });
    } else if (this.userService.getApplicationAccess().indexOf('vistaone') > -1) {
      // check if user has access to vista one, if yes then show vista one as client docs url
      this.buttonLinks.push({
        goToButtonText: 'GO TO DOCUMENTS',
        goToRouterLink: 'https://docs.gcmlp.com/Grosvenor/Release10/me.get?dps.views.show&TOOLS'
      });
    }
  }

  getProfileItems() {
    this.welcomeName = this.userService.getUserFullName() || '';
    this.getAccountMenuItems();
  }

  getAccountMenuItems() {
    this.accountMenuItems = [];
    if (!this.userService.isExternalUser()) {
      this.accountMenuItems.push({ 
        label: 'My Apps', 
        icon: 'apps', 
        href: this.evService.appsUrl, 
        target: '_blank'
      });
    }
    this.accountMenuItems.push({ 
      label: 'Profile', 
      icon: 'manage_accounts', 
      href: this.evService.profileUrl, 
      target: '_blank'
    }, { 
      label: 'Logout', 
      icon: 'exit_to_app', 
      action: () => this.userService.logoutApp()
    });
  }
}
